<template>
  <div class="bbe-inset-table" v-click-outside="close" @click.stop>
    <div class="bbe-inset-table__title">{{title}}</div>
    <div class="bbe-inset-table-body" @click="insetTable()">
      <div class="bbe-inset-table-body-row"
           v-for="(row, indexRow) in rows"
           :key="row + indexRow">
        <div class="bbe-inset-table-body-row__cell"
             :class="{'bbe-inset-table-body-row__cell_active': getActiveCells(indexCol, indexRow)}"
             v-for="(col, indexCol) in columns"
             :key="col + indexCol"
             @mouseenter="setCell(indexCol, indexRow)"/>
      </div>
    </div>
  </div>
</template>

<script>
import {fill, uniqueId} from 'lodash'

export default {
  name: 'InsetTable',
  data () {
    return {
      selectedCells: [0, 0]
    }
  },
  computed: {
    rows () {
      const size = 10
      const array = Array(size)
      return fill(array, uniqueId('bbe-inset-table-row-'))
    },
    columns () {
      const size = 10
      const array = Array(size)
      return fill(array, uniqueId('bbe-inset-table-col-'))
    },
    title () {
      return this.selectedCells.join(' x ')
    }
  },
  methods: {
    getActiveCells (indexCol, indexRow) {
      const col = this.selectedCells[0] - 1
      const row = this.selectedCells[1] - 1
      return col >= indexCol && row >= indexRow
    },
    insetTable () {
      const table = document.createElement('table')
      table.setAttribute('cellpadding', '0')
      table.setAttribute('cellspacing', '0')
      table.classList.add('bbe-inset-table')
      table.style.cssText = 'width: 100%;border-collapse: collapse;'
      const tbody = document.createElement('tbody')
      const rows = this.generateRows()
      tbody.appendChild(rows)
      table.appendChild(tbody)
      this.$emit('insetTable', table)
    },
    generateRows () {
      const rowsSize = this.selectedCells[1]
      const rows = document.createDocumentFragment()
      for (let i = 0; i < rowsSize; i++) {
        const row = document.createElement('tr')
        row.appendChild(this.generateColumns())
        rows.appendChild(row)
      }
      return rows
    },
    generateColumns () {
      const colSize = this.selectedCells[0]
      const cols = document.createDocumentFragment()
      for (let i = 0; i < colSize; i++) {
        const col = document.createElement('td')
        const styles = [
          'min-width: 10px',
          `width: ${100 / colSize}%`,
          'min-height: 100px',
          'padding: 5px',
          'vertical-align: middle',
          'border-width: 1px',
          'border-style: solid',
          'border-color: #dddddd',
          'word-break: break-all'
        ]
        col.style.cssText = styles.join(';')
        cols.appendChild(col)
      }
      return cols
    },
    setCell (col, row) {
      this.selectedCells = [col + 1, row + 1]
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbe-inset-table {
    background-color: $color-white;
    width: 200px;
    padding:  6px 12px 12px;

    &__title {
      margin-bottom: 6px;
    }

    &-body {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: repeat(auto-fill, 14px);
      grid-gap: 4px;
      align-items: center;
      justify-content: center;

      &-row {
        display: grid;
        grid-template-columns: repeat(10, 14px);
        justify-content: space-between;
        width: 100%;
        height: 14px;

        &__cell {
          width: 14px;
          height: 14px;
          border: 1px solid $color-dusty-gray;

          &:hover, &_active {
            background-color: $color-dusty-gray;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/TextEditor/InsetTable/InsetTable.vue